var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8C4.5 8 2.5 9.447 2.5 11.5V13C2.5 14.0609 2.92143 15.0783 3.67157 15.8284C4.42172 16.5786 5.43913 17 6.5 17V8ZM6.5 8C6.5 6.4087 7.13214 4.88258 8.25736 3.75736C9.38258 2.63214 10.9087 2 12.5 2C14.0913 2 15.6174 2.63214 16.7426 3.75736C17.8679 4.88258 18.5 6.4087 18.5 8M18.5 8C20.5 8 22.5 9.447 22.5 11.5V13C22.5 14.0609 22.0786 15.0783 21.3284 15.8284C20.5783 16.5786 19.5609 17 18.5 17V8ZM18.5 16.5V17.5C18.5 19.1569 17.1569 20.5 15.5 20.5M15.5 20.5C15.5 21.3284 14.8284 22 14 22H12C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19H14C14.8284 19 15.5 19.6716 15.5 20.5Z",
    stroke: "#332F5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.fc0d7961d972953b2498095e1c79554d.svg";
export { ForwardRef as ReactComponent };